<div *ngIf="user$ | async as user" class="my-device-form">
  <form
    *ngIf="form && (!!registeredDevices?.controls?.length || !!newDevices?.controls?.length)"
    [formGroup]="form"
    (submit)="onSubmit()"
    novalidate>
    <a *ngIf="navigationBackButton" class="a-link" (click)="onNavigationBack()">
      <img src="../../../../../assets/icons/arrow-back.svg" alt="Buttons" />
      <span class="a-text">{{ 'buttons.labels.back' | translate }}</span>
    </a>

    <h1 class="form-title form-title__bp_lt-md_hidden">
      {{ 'stepper.device' | translate }}
    </h1>

    <p>
      {{ 'captive.form.my-device.subtitle' | translate }}
    </p>

    <div
      class="form-group form-wrapper"
      *ngFor="let registeredDeviceControl of registeredDevices?.controls; let idx = index">
      <app-registered-device
        [idx]="idx"
        [hasProfile]="hasProfile"
        [user]="user"
        [form]="form"
        [deviceControl]="registeredDeviceControl"
        [myDevicesFormState]="myDevicesFormState"
        (changedPassphraseValue)="onChangedPassphrase($event)"
        (unlinkDevice)="onUnlinkSerial($event)" />
    </div>

    <div
      class="form-group form-wrapper"
      *ngFor="let newDeviceControl of newDevices?.controls; let idx = index">
      <app-new-device
        [idx]="idx"
        [hasProfile]="hasProfile"
        [user]="user"
        [form]="form"
        [deviceControl]="newDeviceControl"
        [myDevicesFormState]="myDevicesFormState"
        (changedPassphraseValue)="onChangedPassphrase($event)"
        (removeAddAnotherDevice)="onRemoveAddAnotherDevice($event)" />
    </div>

    <ng-template *ngIf="form.statusChanges | async" />

    <app-button
      *ngIf="addAnotherDeviceButton"
      class="ind-btn-wrapper-100"
      [className]="'ind-btn--primary'"
      type="button"
      [label]="'captive.form.my-device.addAnotherDevice'"
      (click)="onAddNewDevice()" />

    <app-button
      class="ind-btn-wrapper-100"
      [className]="'ind-btn--primary'"
      type="submit"
      [label]="label"
      [isDisabled]="isDisabledUpdateButton()" />
  </form>
</div>
